import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { registerServiceWorker, unregisterServiceWorker } from "./utils/serviceWorkerRegistration";

export const pca = new PublicClientApplication(msalConfig);

async function initializeAndRender() {
  try {
    await pca.initialize();
    
    // Unregister any existing service workers to prevent reload loops
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().then((success) => {
            if (success) {
              console.log('[Service Worker] Unregistered existing service worker');
            }
          });
        });
      });
    }
    
    const root = ReactDOM.createRoot(document.getElementById("root")!);
    root.render(
      <React.StrictMode>
        <MsalProvider instance={pca}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
    
    // Register service worker for PWA (only in production)
    registerServiceWorker();
  } catch (error) {
    console.error("Error initializing MSAL:", error);
  }
}

initializeAndRender();